export default {
	name: 'BrandsView'
}